import utils from '@bigcommerce/stencil-utils';
import autoHighlight from './auto-highlight';
import itemInCart from './card-item-in-cart';
import { getCartPageOvrPricing } from '../custom/shipping/ovr-shipping';
import { sendInteractionEvent } from '../custom/event/analytics-sender';
import { fireRemoveFromCart } from '../custom/event/ga4-events';
import { clearVariantSkuMap, decorateCartItemsWithSkus } from '../custom/event/ga4VariantSkuMap';
import { bus, Events } from '../common/event-bus';

export default function sideCart() {
    // Set up the mutable page height by grabbing it and the cart height then modifying based on one another
    // Also grab viewport height so we can create a scrollable inner element
    let getPageHeight = $('.page').height();
    let getCartHeight = $('.side-cart').height();

    // Only mut the height of elements if not on a mobile device
    if (!/Mobi/i.test(navigator.userAgent)) {
        $('#side-cart-container .side-cart-container').css('height', getPageHeight);
    }

    // Set up the sticky-ness of the side-cart
    const Sticky = require('sticky-js');
    const sticky = new Sticky('#side-cart-container');

    // Update the cart size/dimensions function
    function updateCartSize() {
        // Mut the page height to better contain the side-cart
        getPageHeight = $('.page').height();
        getCartHeight = $('#side-cart-container').height();

        // Check for the existence of the data-sticky-contianer tag to make sure we should mut the page
        const getPageType = $('.page').attr('data-sticky-container');

        if (getPageType && ($(window).width() > 1260)) {
            if (getPageHeight < 685) {
                sticky.destroy();
            }

            if (getCartHeight > 685 && getPageHeight < 734) {
                $('.page-content').css('min-height', getCartHeight + 49);
                $('.side-cart-container').css('min-height', getCartHeight + 26);
            } else {
                switch (getCartHeight > getPageHeight) {
                case true:
                    $('#side-cart-container .side-cart-container').css('min-height', getCartHeight);
                    $('.page-content').css('min-height', getCartHeight + 40);
                    break;
                case false:
                    $('.page-content').css('min-height');
                    sticky.update();
                    break;
                default:
                }
            }
        }

        // This line cuts out a five line else-if. It's not meant to be called after being created, just invoked upon birth.
        const sideCartPopulatedCheck = (!$('.side-cart-item').text()) ? $('.side-cart-placeholder').css('display', 'block') : false; // eslint-disable-line no-unused-vars

        autoHighlight();
    }

    // Update the cart function
    function updateCart() {

        const $sideCart = $('.side-cart-content');
        const $sideCartDetails = $('.side-cart-details');
        const $sideCartActions = $('.side-cart-actions');

        $('.side-cart-loading').css('display', 'block');
        $('.side-cart-item').css('opacity', '0.5');

        const options = {
            template: {
                content: 'f/b2b/side-cart-content',
                details: 'f/b2b/side-cart-details',
                actions: 'f/b2b/side-cart-actions',
                counter: 'f/cart/item-count',
            },
        };



        // Step 1: Get updated content and update UI
        utils.api.cart.getContent(options, (err, response) => {
            if (err) {
                console.error("Error retrieving cart content: ", err);
                $('.side-cart-loading').css('display', 'none');
                $('.side-cart-item').css('opacity', '1');
                return;
            }

            if (response == null) {
                return;
            }

            $sideCart.html(response.content);
            $sideCartDetails.html(response.details);
            $sideCartActions.html(response.actions);
            $('.cart-quantity').html(response.counter);

            // This line cuts out a five line else-if. It's not meant to be called after being created, just invoked upon birth.
            const sideCartPopulatedCheck = (!$('.side-cart-item').text()) ? $('.side-cart-placeholder').css('display', 'block') : false; // eslint-disable-line no-unused-vars
            if(response.counter == 0 && !sideCartPopulatedCheck){
                $('.side-cart-placeholder').css('display', 'block');
            }
            $('body').trigger('cart-quantity-update', response.counter); // legacy
            bus.emit(Events.CART_UPDATED, { quantity: response.counter });

            $('.side-cart-loading').css('display', 'none');
            $('.side-cart-item').css('opacity', '1');

            // Step 2: NOW get cart data and update pricing (after UI is ready)
            utils.api.cart.getCart({}, (err, cartResponse) => {
                const sendURL = onlineServiceUrl ?? 'https://api.storesupply.com/';
                const tru = true;

                if (err) {
                    console.error("Error retrieving cart data: ", err);
                    return;
                }

                const physicalItems = cartResponse?.lineItems?.physicalItems ?? null;
                getCartPageOvrPricing(physicalItems, sendURL, tru);

                // Step 3: Update item in cart indicators AFTER all cart data is loaded
                itemInCart();
            });
        });

        updateCartSize();

    }

    // Popup function for input notification
    function popup(target, parent, child, str, delay) {
        const $popup = $(target).parents(`${parent}`).find(`${child}`);

        $popup.html(`${str}`);
        $popup.fadeIn(0).delay(delay).fadeOut(0);
    }

    // Debouncer fucntion to stop mut catching spam
    function debounce(func, wait, immediate, ...args) {
        let timeout;
        return function bounced() {
            const context = this;
            const later = function timedOut() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    // Setup a listener for window resizing/scrolling to help keep side-cart boundaries compliant
    const catchWindowResize = debounce(() => {
        updateCartSize();
    }, 350);

    $(window).resize(catchWindowResize);
    $(window).scroll(catchWindowResize);

    // Update a product quantity
    $(document).on('change', '.side-cart-item-qty-input', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        const $input = $(event.currentTarget);
        const itemIdData = $input.data('id');
        const inputVal = $input.val();

        // Validate that we have the required data
        if (!itemIdData || typeof itemIdData !== 'string' || itemIdData.length <= 4) {
            console.error('Invalid item ID data:', itemIdData);
            popup(event.currentTarget, '.side-cart-item-info', '.change-side-cart-qty', 'Unable to update item quantity', 2000);
            return;
        }

        const itemId = itemIdData.substring(4);
        const newQty = parseInt(inputVal, 10);

        // Validate quantity is a valid number
        if (isNaN(newQty) || newQty < 0) {
            console.error('Invalid quantity:', inputVal);
            popup(event.currentTarget, '.side-cart-item-info', '.change-side-cart-qty', 'Please enter a valid quantity', 2000);
            return;
        }

        utils.api.cart.itemUpdate(itemId, newQty, (err, response) => {
            // Handle API errors
            if (err) {
                console.error('Error updating cart item:', err);
                popup(event.currentTarget, '.side-cart-item-info', '.change-side-cart-qty', 'Failed to update quantity. Please try again.', 2000);
                return;
            }

            // Validate response structure and check for errors
            if (response && response.data && Array.isArray(response.data.errors) && response.data.errors.length > 0) {
                const currentErr = response.data.errors.join('\n');
                const errMax = currentErr.search(/maximum/i);
                const errMin = currentErr.search(/minimum/i);
                const errStock = currentErr.search(/enough/i);

                if (errMax !== -1) {
                    const maxError = $input.data('quantity-max-error') || 'Quantity exceeds maximum allowed';
                    popup(event.currentTarget, '.side-cart-item-info', '.change-side-cart-qty', maxError, 2000);
                } else if (errMin !== -1) {
                    const minError = $input.data('quantity-min-error') || 'Quantity below minimum required';
                    popup(event.currentTarget, '.side-cart-item-info', '.change-side-cart-qty', minError, 2000);
                } else if (errStock !== -1) {
                    const stockError = $input.data('stock-error') || 'Not enough stock available';
                    popup(event.currentTarget, '.side-cart-item-info', '.change-side-cart-qty', stockError, 2000);
                } else {
                    popup(event.currentTarget, '.side-cart-item-info', '.change-side-cart-qty', currentErr, 2000);
                }
                autoHighlight();
            } else {
                // Success - update the cart
                updateCart();
            }
        });
    });

    // Track items being removed to prevent duplicate removal attempts
    const removingItems = new Set();

    // Remove item from the cart function
    function cartRemoveItem(itemId) {
        // Prevent duplicate removal attempts
        if (removingItems.has(itemId)) {
            console.warn(`Item ${itemId} is already being removed`);
            return;
        }

        removingItems.add(itemId);

        utils.api.cart.itemRemove(itemId, (err, response) => {
            // Remove from tracking set when complete
            removingItems.delete(itemId);

            if (err) {
                console.error("Error removing item from cart: ", err);
                return;
            }

            if (response) { // Catch for if you try to remove the item before the cart has been updated with it server-side
                if (response.data.status === 'succeed') {
                    const removedItem = response.data.line_items?.[0];
                    if (removedItem) {
                        decorateCartItemsWithSkus([removedItem]);
                        fireRemoveFromCart(removedItem, response.data.currency);
                    }

                    utils.api.cart.getCartQuantity({}, (qtyErr, qty) => {
                        if (!qtyErr && (qty || 0) === 0) clearVariantSkuMap();
                    });

                    updateCart();
                    // itemInCart is now called within updateCart after all data is loaded
                } else {
                    updateCart();
                    alert(response.data.errors.join('\n'));
                }
            }
        });
    }

    // Remove an item from the cart trigger
    $(document).on('click', '.cart-remove', async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        const $target = $(event.currentTarget);
        const itemId = $target.data('cart-itemid');
        const productId = $target.data('product-id');
        const sku = $target.data('product-sku');

        // Fire the remove_from_cart_start event via the shared online-services sender
        // (await so the beacon dispatches before cartRemoveItem triggers UI churn)
        await sendInteractionEvent('remove_from_cart_start', {
            cartItemId: itemId,
            productId: productId,
            source: 'side_cart',
            productSKU: sku,
            timestamp: new Date().toISOString(),
        });

        cartRemoveItem(itemId);
    });

    // Update everything
    updateCart();
}
